import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { ReportsCreateControllerModule } from './controllers/ReportsCreateController';

export const ReportsCreateView = angular
  .module('acme.view.application.reports.create', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.directive.dataGrid',
    'acme.common.directive.datePicker',
    'acme.common.directive.fieldFocus',
    ReportsCreateControllerModule,
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const reportsCreate = {
      name: 'application.reports.create',
      url: '/create/:id',
      views: {
        'subview-main': {
          controller: 'ReportsCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/reports/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Run Report',
        permissions: [
          'REPORTS_CREATE',
          'REPORTS_UPDATE',
          'REPORTS_EXECUTE',
          'REPORTS_OWNER_EXECUTE',
          'REPORTS_DOWNLOAD',
        ],
      },
    };

    $stateProvider.state(reportsCreate);
  }).name;
